export const getSessionId = () => {
  let sessionId = sessionStorage.getItem("session");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("session", sessionId);
  }
  return sessionId;
};
